



























































































import { Component, Vue } from 'vue-property-decorator';
import LogIn from '@/components/auth/LogIn.vue';
import SignUp from '@/components/auth/SignUp.vue';

@Component({
  components: { SignUp, LogIn }
})
export default class NavigationDrawerMenu extends Vue {
  showLogin: boolean = false;
  showRegister: boolean = false;

  public logout () {
    this.$store.dispatch('AUTH_LOGOUT').then(() => {
      this.$router.push({ name: 'home' });
    });
  }
}
